import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TotaraHttpClient } from '@cms_root/app/api-clients/totara/totara-http-client.service';
import { environment } from '@cms_root/environments/environment';
import { LoginResponse } from '../../base/models/login-response.model';
import { AuthBaseApi } from '../../base/services/auth-base-api';

@Injectable({
  providedIn: 'root'
})
export class TotaraAuthApiService implements AuthBaseApi {
  private readonly loginUrl = `${environment.totaraApi}waauth/login`;

  constructor(private readonly httpClient: TotaraHttpClient) {}

  login(authSessionId: string): Observable<LoginResponse> {
    return this.httpClient.post<LoginResponse>(
      this.loginUrl,
      { authSessionId },
      {
        withCredentials: true
      }
    );
  }
}
